export default __webpack_public_path__ + "static/media/069-rabbit.63ea572d.svg";